/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_PainInputs */

const en_us2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We remove exercises that load the area. The app adapts; it never treats injuries.`)
};

const pt_br2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiramos exercícios que carregam a região. O app adapta, nunca trata lesões.`)
};

const es_419_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitamos los ejercicios que cargan esa zona. La app se adapta; nunca trata lesiones.`)
};

const pt_pt2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiramos exercícios que sobrecarregam a zona. A app adapta-se, nunca trata lesões.`)
};

const fr_fr2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On retire les exercices qui sollicitent la zone. L'app s'adapte ; elle ne soigne jamais de blessure.`)
};

const de_de2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir nehmen Übungen raus, die die Stelle belasten. Die App passt sich an; sie behandelt nie Verletzungen.`)
};

const it_it2_profile_why_pain = /** @type {(inputs: Profile_Why_PainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Togliamo gli esercizi che caricano la zona. L'app si adatta; non cura mai gli infortuni.`)
};

/**
* | output |
* | --- |
* | "We remove exercises that load the area. The app adapts; it never treats injuries." |
*
* @param {Profile_Why_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_pain = /** @type {((inputs?: Profile_Why_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_pain(inputs)
	if (locale === "es-419") return es_419_profile_why_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_pain(inputs)
	if (locale === "de-DE") return de_de2_profile_why_pain(inputs)
	if (locale === "it-IT") return it_it2_profile_why_pain(inputs)
	return en_us2_profile_why_pain(inputs)
});
export { profile_why_pain as "profile.why_pain" }